<script setup>
import NavigationSubMenu from '@/Components/Navigation/NavigationSubMenu.vue';
import {Link} from '@inertiajs/vue3';
import {inject} from 'vue';

defineProps({
    menuItems: Object,
});

const openMobileMenu = inject('openMobileMenu');
</script>

<template>
    <nav class="flex flex-col">
        <ul
            v-if="menuItems"
            :class="{ flex: openMobileMenu, hidden: !openMobileMenu }"
            class="relative z-20 grow flex-col gap-8 pb-4 xl:flex xl:h-auto xl:flex-row xl:items-center xl:justify-end xl:pb-0 2xl:gap-6"
        >
            <li
                v-for="link in menuItems"
                :key="link.id"
                class="flex"
            >
                <component
                    :is="link.data.new_tab ? 'a' : Link"
                    v-if="link.type.includes('MenuItem') && link.data.url"
                    :href="link.data.url"
                    :target="link.data.new_tab ? '_blank' : ''"
                    class="font-bold transition-colors duration-300"
                >
                    <span> {{ link.data.title }}</span>
                </component>

                <NavigationSubMenu
                    v-if="link.type.includes('SubMenu')"
                    :child-items="link.data.sub_menu"
                    :title="link.data.title"
                />
            </li>
        </ul>
    </nav>
</template>
